import * as React from "react";
const SvgErsteSeite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="ErsteSeite">
    <path
      fill="currentColor"
      d="M215.53 199.41V56.59c0-5.2-5.63-8.45-10.14-5.85L81.71 122.15c-4.51 2.6-4.51 9.1 0 11.7l123.68 71.41c4.51 2.6 10.14-.65 10.14-5.85m-15-14.28L101.57 128l98.96-57.13v114.27Z"
    />
    <rect x={40.47} y={44.31} fill="currentColor" rx={7.5} ry={7.5} />
  </svg>
);
export default SvgErsteSeite;
